import { SectionLayout } from '@/pages/shared-components/SectionLayout'
import { ApplicationsBreadcrumb } from '../ApplicationsBreadcrumbs'
import { ActionsSection } from './ActionsSection'
import { useCallback, useState } from 'react'
import { SyncImportSection } from './SyncImportSection'

export const AppSyncPageV3 = () => {
  const [files, setFiles] = useState<File[]>([])
  const reset = useCallback(() => {
    setFiles([])
  }, [])
  const hasFiles = files.length > 0
  return (
    <>
      <ApplicationsBreadcrumb title="Sync" />
      <SectionLayout>
        <ActionsSection files={files} setFiles={setFiles} hasFiles={hasFiles} />
        <SyncImportSection file={files[0]} reset={reset} />
      </SectionLayout>
    </>
  )
}
